/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Order limit per period (DAY, WEEK, MONTH)
 * @export
 * @interface AddCatalogItemRequestOrderLimit
 */
export interface AddCatalogItemRequestOrderLimit {
    /**
     * 
     * @type {string}
     * @memberof AddCatalogItemRequestOrderLimit
     */
    period?: AddCatalogItemRequestOrderLimitPeriodEnum;
    /**
     * 
     * @type {number}
     * @memberof AddCatalogItemRequestOrderLimit
     */
    maxQuantity?: number;
}


/**
 * @export
 */
export const AddCatalogItemRequestOrderLimitPeriodEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
} as const;
export type AddCatalogItemRequestOrderLimitPeriodEnum = typeof AddCatalogItemRequestOrderLimitPeriodEnum[keyof typeof AddCatalogItemRequestOrderLimitPeriodEnum];


/**
 * Check if a given object implements the AddCatalogItemRequestOrderLimit interface.
 */
export function instanceOfAddCatalogItemRequestOrderLimit(value: object): value is AddCatalogItemRequestOrderLimit {
    return true;
}

export function AddCatalogItemRequestOrderLimitFromJSON(json: any): AddCatalogItemRequestOrderLimit {
    return AddCatalogItemRequestOrderLimitFromJSONTyped(json, false);
}

export function AddCatalogItemRequestOrderLimitFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCatalogItemRequestOrderLimit {
    if (json == null) {
        return json;
    }
    return {
        
        'period': json['period'] == null ? undefined : json['period'],
        'maxQuantity': json['maxQuantity'] == null ? undefined : json['maxQuantity'],
    };
}

export function AddCatalogItemRequestOrderLimitToJSON(value?: AddCatalogItemRequestOrderLimit | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'period': value['period'],
        'maxQuantity': value['maxQuantity'],
    };
}

